import {RouteComponentProps} from "react-router-dom";

export const ADMISSION_EXPERIENCE_ROUTE = "/admission/explore/:admissionId";

export type AdmissionExperienceRouteProps = RouteComponentProps<{
  admissionId: string;
}>;
